import React from 'react';
import PropTypes from "prop-types";

const Notification = props => {
  const {role} = props.auth.user;

  return (
      <tr>
        <td>{props.notification.text}</td>
        <td>
          <button type="button" className="btn btn-link"
                  onClick={() => props.markAsSeen(props.notification.id, role)}>mark as seen
          </button>
        </td>
      </tr>
  );
};

Notification.propTypes = {
  notification: PropTypes.object,
  auth: PropTypes.object.isRequired,
  markAsSeen: PropTypes.func.isRequired
};

export default Notification;



// WEBPACK FOOTER //
// ./src/components/NotificationsList/Notification.jsx